import { _ as e } from "./index.es456.js";
var r = e, o = typeof self == "object" && self && self.Object === Object && self, t = r || o || Function("return this")(), l = t;
export {
  l as _
};
//# sourceMappingURL=index.es384.js.map
